import { ShieldCheck, Zap, Building } from 'lucide-react';
import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
          <span className="block">Fire Alarm System Design</span>
          <span className="block text-blue-500">NFPA 72 Precision + AI Review</span>
        </h1>
        <div className="mt-6 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
          <div className="rounded-md shadow">
            <Link to="/quote" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600 md:py-4 md:text-lg md:px-10">
              Request Fire Alarm Quote
            </Link>
          </div>
          <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
            <a href="tel:8185338313" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-500 bg-white hover:bg-slate-50 md:py-4 md:text-lg md:px-10">
              Call (818) 533-8313
            </a>
          </div>
        </div>
        <div className="mt-10">
          <div className="flex justify-center space-x-4">
            <div className="flex items-center text-sm font-medium text-slate-500">
              <ShieldCheck className="w-5 h-5 mr-1.5 text-green-500" />
              NFPA 72 / NEC 760 / IBC-IFC
            </div>
            <div className="flex items-center text-sm font-medium text-slate-500">
              <Zap className="w-5 h-5 mr-1.5 text-green-500" />
              AI-Enhanced Plan Reviews
            </div>
            <div className="flex items-center text-sm font-medium text-slate-500">
              <Building className="w-5 h-5 mr-1.5 text-green-500" />
              Licensed Engineer • LA County
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
